// ABOUTME: The "Confirm your brand kit" state (GET /brand-kits/confirmation) and the confirm
// write (POST /brand-kits/confirm). Types mirror the backend's kit summary in snake_case.
import { useQuery } from '@tanstack/react-query'
import { api } from './client'

export interface BrandKitSummary {
  id: string
  name: string
  logo_url: string | null
  primary_color: string | null
  secondary_color: string | null
  accent_color: string | null
  heading_font: string | null
  body_font: string | null
  confirmed_at: string | null
}

export type BrandKitEdits = Partial<
  Pick<
    BrandKitSummary,
    'primary_color' | 'secondary_color' | 'accent_color' | 'heading_font' | 'body_font'
  >
>

export interface BrandKitConfirmation {
  needs_confirmation: boolean
  kit: BrandKitSummary | null
}

// Under the content_history prefix: a finished website import refreshes it.
export const BRAND_KIT_CONFIRMATION_KEY = [
  'domain',
  'content_history',
  'brand-kit-confirmation',
] as const

export function getBrandKitConfirmation(): Promise<BrandKitConfirmation> {
  return api.get<BrandKitConfirmation>('/brand-kits/confirmation')
}

export function confirmBrandKit(kitId: string, edits: BrandKitEdits): Promise<BrandKitSummary> {
  return api.post<BrandKitSummary>('/brand-kits/confirm', { kit_id: kitId, edits })
}

export function useBrandKitConfirmation() {
  return useQuery({
    queryKey: BRAND_KIT_CONFIRMATION_KEY,
    queryFn: getBrandKitConfirmation,
    refetchInterval: 60_000,
  })
}
